// extracted by mini-css-extract-plugin
module.exports = {"buttonholder":"Record_buttonholder__3V1Um","addbutton":"Record_addbutton__1STVw"};